var j;
(function (r) {
  (r.Range = "range"),
    (r.Steps = "steps"),
    (r.Positions = "positions"),
    (r.Count = "count"),
    (r.Values = "values");
})(j || (j = {}));
var U;
(function (r) {
  (r[(r.None = -1)] = "None"),
    (r[(r.NoValue = 0)] = "NoValue"),
    (r[(r.LargeValue = 1)] = "LargeValue"),
    (r[(r.SmallValue = 2)] = "SmallValue");
})(U || (U = {}));
function mt(r) {
  return Z(r) && typeof r.from == "function";
}
function Z(r) {
  return typeof r == "object" && typeof r.to == "function";
}
function Ue(r) {
  r.parentElement.removeChild(r);
}
function de(r) {
  return r != null;
}
function Me(r) {
  r.preventDefault();
}
function vt(r) {
  return r.filter(function (e) {
    return this[e] ? !1 : (this[e] = !0);
  }, {});
}
function gt(r, e) {
  return Math.round(r / e) * e;
}
function St(r, e) {
  var s = r.getBoundingClientRect(),
    l = r.ownerDocument,
    o = l.documentElement,
    h = ze(l);
  return (
    /webkit.*Chrome.*Mobile/i.test(navigator.userAgent) && (h.x = 0),
    e ? s.top + h.y - o.clientTop : s.left + h.x - o.clientLeft
  );
}
function R(r) {
  return typeof r == "number" && !isNaN(r) && isFinite(r);
}
function He(r, e, s) {
  s > 0 &&
    (D(r, e),
    setTimeout(function () {
      J(r, e);
    }, s));
}
function Re(r) {
  return Math.max(Math.min(r, 100), 0);
}
function Q(r) {
  return Array.isArray(r) ? r : [r];
}
function wt(r) {
  r = String(r);
  var e = r.split(".");
  return e.length > 1 ? e[1].length : 0;
}
function D(r, e) {
  r.classList && !/\s/.test(e) ? r.classList.add(e) : (r.className += " " + e);
}
function J(r, e) {
  r.classList && !/\s/.test(e)
    ? r.classList.remove(e)
    : (r.className = r.className.replace(
        new RegExp("(^|\\b)" + e.split(" ").join("|") + "(\\b|$)", "gi"),
        " "
      ));
}
function xt(r, e) {
  return r.classList
    ? r.classList.contains(e)
    : new RegExp("\\b" + e + "\\b").test(r.className);
}
function ze(r) {
  var e = window.pageXOffset !== void 0,
    s = (r.compatMode || "") === "CSS1Compat",
    l = e
      ? window.pageXOffset
      : s
      ? r.documentElement.scrollLeft
      : r.body.scrollLeft,
    o = e
      ? window.pageYOffset
      : s
      ? r.documentElement.scrollTop
      : r.body.scrollTop;
  return { x: l, y: o };
}
function bt() {
  return window.navigator.pointerEnabled
    ? { start: "pointerdown", move: "pointermove", end: "pointerup" }
    : window.navigator.msPointerEnabled
    ? { start: "MSPointerDown", move: "MSPointerMove", end: "MSPointerUp" }
    : {
        start: "mousedown touchstart",
        move: "mousemove touchmove",
        end: "mouseup touchend",
      };
}
function Et() {
  var r = !1;
  try {
    var e = Object.defineProperty({}, "passive", {
      get: function () {
        r = !0;
      },
    });
    window.addEventListener("test", null, e);
  } catch {}
  return r;
}
function Ct() {
  return window.CSS && CSS.supports && CSS.supports("touch-action", "none");
}
function ve(r, e) {
  return 100 / (e - r);
}
function me(r, e, s) {
  return (e * 100) / (r[s + 1] - r[s]);
}
function _t(r, e) {
  return me(r, r[0] < 0 ? e + Math.abs(r[0]) : e - r[0], 0);
}
function yt(r, e) {
  return (e * (r[1] - r[0])) / 100 + r[0];
}
function B(r, e) {
  for (var s = 1; r >= e[s]; ) s += 1;
  return s;
}
function Pt(r, e, s) {
  if (s >= r.slice(-1)[0]) return 100;
  var l = B(s, r),
    o = r[l - 1],
    h = r[l],
    p = e[l - 1],
    S = e[l];
  return p + _t([o, h], s) / ve(p, S);
}
function At(r, e, s) {
  if (s >= 100) return r.slice(-1)[0];
  var l = B(s, e),
    o = r[l - 1],
    h = r[l],
    p = e[l - 1],
    S = e[l];
  return yt([o, h], (s - p) * ve(p, S));
}
function kt(r, e, s, l) {
  if (l === 100) return l;
  var o = B(l, r),
    h = r[o - 1],
    p = r[o];
  return s
    ? l - h > (p - h) / 2
      ? p
      : h
    : e[o - 1]
    ? r[o - 1] + gt(l - r[o - 1], e[o - 1])
    : l;
}
var Fe = (function () {
    function r(e, s, l) {
      (this.xPct = []),
        (this.xVal = []),
        (this.xSteps = []),
        (this.xNumSteps = []),
        (this.xHighestCompleteStep = []),
        (this.xSteps = [l || !1]),
        (this.xNumSteps = [!1]),
        (this.snap = s);
      var o,
        h = [];
      for (
        Object.keys(e).forEach(function (p) {
          h.push([Q(e[p]), p]);
        }),
          h.sort(function (p, S) {
            return p[0][0] - S[0][0];
          }),
          o = 0;
        o < h.length;
        o++
      )
        this.handleEntryPoint(h[o][1], h[o][0]);
      for (
        this.xNumSteps = this.xSteps.slice(0), o = 0;
        o < this.xNumSteps.length;
        o++
      )
        this.handleStepPoint(o, this.xNumSteps[o]);
    }
    return (
      (r.prototype.getDistance = function (e) {
        for (var s = [], l = 0; l < this.xNumSteps.length - 1; l++)
          s[l] = me(this.xVal, e, l);
        return s;
      }),
      (r.prototype.getAbsoluteDistance = function (e, s, l) {
        var o = 0;
        if (e < this.xPct[this.xPct.length - 1])
          for (; e > this.xPct[o + 1]; ) o++;
        else
          e === this.xPct[this.xPct.length - 1] && (o = this.xPct.length - 2);
        !l && e === this.xPct[o + 1] && o++, s === null && (s = []);
        var h,
          p = 1,
          S = s[o],
          m = 0,
          P = 0,
          H = 0,
          A = 0;
        for (
          l
            ? (h = (e - this.xPct[o]) / (this.xPct[o + 1] - this.xPct[o]))
            : (h = (this.xPct[o + 1] - e) / (this.xPct[o + 1] - this.xPct[o]));
          S > 0;

        )
          (m = this.xPct[o + 1 + A] - this.xPct[o + A]),
            s[o + A] * p + 100 - h * 100 > 100
              ? ((P = m * h), (p = (S - 100 * h) / s[o + A]), (h = 1))
              : ((P = ((s[o + A] * m) / 100) * p), (p = 0)),
            l
              ? ((H = H - P), this.xPct.length + A >= 1 && A--)
              : ((H = H + P), this.xPct.length - A >= 1 && A++),
            (S = s[o + A] * p);
        return e + H;
      }),
      (r.prototype.toStepping = function (e) {
        return (e = Pt(this.xVal, this.xPct, e)), e;
      }),
      (r.prototype.fromStepping = function (e) {
        return At(this.xVal, this.xPct, e);
      }),
      (r.prototype.getStep = function (e) {
        return (e = kt(this.xPct, this.xSteps, this.snap, e)), e;
      }),
      (r.prototype.getDefaultStep = function (e, s, l) {
        var o = B(e, this.xPct);
        return (
          (e === 100 || (s && e === this.xPct[o - 1])) &&
            (o = Math.max(o - 1, 1)),
          (this.xVal[o] - this.xVal[o - 1]) / l
        );
      }),
      (r.prototype.getNearbySteps = function (e) {
        var s = B(e, this.xPct);
        return {
          stepBefore: {
            startValue: this.xVal[s - 2],
            step: this.xNumSteps[s - 2],
            highestStep: this.xHighestCompleteStep[s - 2],
          },
          thisStep: {
            startValue: this.xVal[s - 1],
            step: this.xNumSteps[s - 1],
            highestStep: this.xHighestCompleteStep[s - 1],
          },
          stepAfter: {
            startValue: this.xVal[s],
            step: this.xNumSteps[s],
            highestStep: this.xHighestCompleteStep[s],
          },
        };
      }),
      (r.prototype.countStepDecimals = function () {
        var e = this.xNumSteps.map(wt);
        return Math.max.apply(null, e);
      }),
      (r.prototype.hasNoSize = function () {
        return this.xVal[0] === this.xVal[this.xVal.length - 1];
      }),
      (r.prototype.convert = function (e) {
        return this.getStep(this.toStepping(e));
      }),
      (r.prototype.handleEntryPoint = function (e, s) {
        var l;
        if (
          (e === "min"
            ? (l = 0)
            : e === "max"
            ? (l = 100)
            : (l = parseFloat(e)),
          !R(l) || !R(s[0]))
        )
          throw new Error("noUiSlider: 'range' value isn't numeric.");
        this.xPct.push(l), this.xVal.push(s[0]);
        var o = Number(s[1]);
        l
          ? this.xSteps.push(isNaN(o) ? !1 : o)
          : isNaN(o) || (this.xSteps[0] = o),
          this.xHighestCompleteStep.push(0);
      }),
      (r.prototype.handleStepPoint = function (e, s) {
        if (s) {
          if (this.xVal[e] === this.xVal[e + 1]) {
            this.xSteps[e] = this.xHighestCompleteStep[e] = this.xVal[e];
            return;
          }
          this.xSteps[e] =
            me([this.xVal[e], this.xVal[e + 1]], s, 0) /
            ve(this.xPct[e], this.xPct[e + 1]);
          var l = (this.xVal[e + 1] - this.xVal[e]) / this.xNumSteps[e],
            o = Math.ceil(Number(l.toFixed(3)) - 1),
            h = this.xVal[e] + this.xNumSteps[e] * o;
          this.xHighestCompleteStep[e] = h;
        }
      }),
      r
    );
  })(),
  Oe = {
    to: function (r) {
      return r === void 0 ? "" : r.toFixed(2);
    },
    from: Number,
  },
  qe = {
    target: "target",
    base: "base",
    origin: "origin",
    handle: "handle",
    handleLower: "handle-lower",
    handleUpper: "handle-upper",
    touchArea: "touch-area",
    horizontal: "horizontal",
    vertical: "vertical",
    background: "background",
    connect: "connect",
    connects: "connects",
    ltr: "ltr",
    rtl: "rtl",
    textDirectionLtr: "txt-dir-ltr",
    textDirectionRtl: "txt-dir-rtl",
    draggable: "draggable",
    drag: "state-drag",
    tap: "state-tap",
    active: "active",
    tooltip: "tooltip",
    pips: "pips",
    pipsHorizontal: "pips-horizontal",
    pipsVertical: "pips-vertical",
    marker: "marker",
    markerHorizontal: "marker-horizontal",
    markerVertical: "marker-vertical",
    markerNormal: "marker-normal",
    markerLarge: "marker-large",
    markerSub: "marker-sub",
    value: "value",
    valueHorizontal: "value-horizontal",
    valueVertical: "value-vertical",
    valueNormal: "value-normal",
    valueLarge: "value-large",
    valueSub: "value-sub",
  },
  q = { tooltips: ".__tooltips", aria: ".__aria" };
function Lt(r, e) {
  if (!R(e)) throw new Error("noUiSlider: 'step' is not numeric.");
  r.singleStep = e;
}
function Vt(r, e) {
  if (!R(e))
    throw new Error("noUiSlider: 'keyboardPageMultiplier' is not numeric.");
  r.keyboardPageMultiplier = e;
}
function Dt(r, e) {
  if (!R(e))
    throw new Error("noUiSlider: 'keyboardMultiplier' is not numeric.");
  r.keyboardMultiplier = e;
}
function Ut(r, e) {
  if (!R(e))
    throw new Error("noUiSlider: 'keyboardDefaultStep' is not numeric.");
  r.keyboardDefaultStep = e;
}
function Mt(r, e) {
  if (typeof e != "object" || Array.isArray(e))
    throw new Error("noUiSlider: 'range' is not an object.");
  if (e.min === void 0 || e.max === void 0)
    throw new Error("noUiSlider: Missing 'min' or 'max' in 'range'.");
  r.spectrum = new Fe(e, r.snap || !1, r.singleStep);
}
function Ht(r, e) {
  if (((e = Q(e)), !Array.isArray(e) || !e.length))
    throw new Error("noUiSlider: 'start' option is incorrect.");
  (r.handles = e.length), (r.start = e);
}
function Rt(r, e) {
  if (typeof e != "boolean")
    throw new Error("noUiSlider: 'snap' option must be a boolean.");
  r.snap = e;
}
function Ot(r, e) {
  if (typeof e != "boolean")
    throw new Error("noUiSlider: 'animate' option must be a boolean.");
  r.animate = e;
}
function zt(r, e) {
  if (typeof e != "number")
    throw new Error("noUiSlider: 'animationDuration' option must be a number.");
  r.animationDuration = e;
}
function Ft(r, e) {
  var s = [!1],
    l;
  if (
    (e === "lower" ? (e = [!0, !1]) : e === "upper" && (e = [!1, !0]),
    e === !0 || e === !1)
  ) {
    for (l = 1; l < r.handles; l++) s.push(e);
    s.push(!1);
  } else {
    if (!Array.isArray(e) || !e.length || e.length !== r.handles + 1)
      throw new Error(
        "noUiSlider: 'connect' option doesn't match handle count."
      );
    s = e;
  }
  r.connect = s;
}
function qt(r, e) {
  switch (e) {
    case "horizontal":
      r.ort = 0;
      break;
    case "vertical":
      r.ort = 1;
      break;
    default:
      throw new Error("noUiSlider: 'orientation' option is invalid.");
  }
}
function je(r, e) {
  if (!R(e)) throw new Error("noUiSlider: 'margin' option must be numeric.");
  e !== 0 && (r.margin = r.spectrum.getDistance(e));
}
function jt(r, e) {
  if (!R(e)) throw new Error("noUiSlider: 'limit' option must be numeric.");
  if (((r.limit = r.spectrum.getDistance(e)), !r.limit || r.handles < 2))
    throw new Error(
      "noUiSlider: 'limit' option is only supported on linear sliders with 2 or more handles."
    );
}
function Tt(r, e) {
  var s;
  if (!R(e) && !Array.isArray(e))
    throw new Error(
      "noUiSlider: 'padding' option must be numeric or array of exactly 2 numbers."
    );
  if (Array.isArray(e) && !(e.length === 2 || R(e[0]) || R(e[1])))
    throw new Error(
      "noUiSlider: 'padding' option must be numeric or array of exactly 2 numbers."
    );
  if (e !== 0) {
    for (
      Array.isArray(e) || (e = [e, e]),
        r.padding = [
          r.spectrum.getDistance(e[0]),
          r.spectrum.getDistance(e[1]),
        ],
        s = 0;
      s < r.spectrum.xNumSteps.length - 1;
      s++
    )
      if (r.padding[0][s] < 0 || r.padding[1][s] < 0)
        throw new Error(
          "noUiSlider: 'padding' option must be a positive number(s)."
        );
    var l = e[0] + e[1],
      o = r.spectrum.xVal[0],
      h = r.spectrum.xVal[r.spectrum.xVal.length - 1];
    if (l / (h - o) > 1)
      throw new Error(
        "noUiSlider: 'padding' option must not exceed 100% of the range."
      );
  }
}
function Kt(r, e) {
  switch (e) {
    case "ltr":
      r.dir = 0;
      break;
    case "rtl":
      r.dir = 1;
      break;
    default:
      throw new Error("noUiSlider: 'direction' option was not recognized.");
  }
}
function Nt(r, e) {
  if (typeof e != "string")
    throw new Error(
      "noUiSlider: 'behaviour' must be a string containing options."
    );
  var s = e.indexOf("tap") >= 0,
    l = e.indexOf("drag") >= 0,
    o = e.indexOf("fixed") >= 0,
    h = e.indexOf("snap") >= 0,
    p = e.indexOf("hover") >= 0,
    S = e.indexOf("unconstrained") >= 0,
    m = e.indexOf("drag-all") >= 0,
    P = e.indexOf("smooth-steps") >= 0;
  if (o) {
    if (r.handles !== 2)
      throw new Error(
        "noUiSlider: 'fixed' behaviour must be used with 2 handles"
      );
    je(r, r.start[1] - r.start[0]);
  }
  if (S && (r.margin || r.limit))
    throw new Error(
      "noUiSlider: 'unconstrained' behaviour cannot be used with margin or limit"
    );
  r.events = {
    tap: s || h,
    drag: l,
    dragAll: m,
    smoothSteps: P,
    fixed: o,
    snap: h,
    hover: p,
    unconstrained: S,
  };
}
function $t(r, e) {
  if (e !== !1)
    if (e === !0 || Z(e)) {
      r.tooltips = [];
      for (var s = 0; s < r.handles; s++) r.tooltips.push(e);
    } else {
      if (((e = Q(e)), e.length !== r.handles))
        throw new Error("noUiSlider: must pass a formatter for all handles.");
      e.forEach(function (l) {
        if (typeof l != "boolean" && !Z(l))
          throw new Error(
            "noUiSlider: 'tooltips' must be passed a formatter or 'false'."
          );
      }),
        (r.tooltips = e);
    }
}
function Bt(r, e) {
  if (e.length !== r.handles)
    throw new Error("noUiSlider: must pass a attributes for all handles.");
  r.handleAttributes = e;
}
function It(r, e) {
  if (!Z(e)) throw new Error("noUiSlider: 'ariaFormat' requires 'to' method.");
  r.ariaFormat = e;
}
function Xt(r, e) {
  if (!mt(e))
    throw new Error("noUiSlider: 'format' requires 'to' and 'from' methods.");
  r.format = e;
}
function Yt(r, e) {
  if (typeof e != "boolean")
    throw new Error("noUiSlider: 'keyboardSupport' option must be a boolean.");
  r.keyboardSupport = e;
}
function Wt(r, e) {
  r.documentElement = e;
}
function Gt(r, e) {
  if (typeof e != "string" && e !== !1)
    throw new Error("noUiSlider: 'cssPrefix' must be a string or `false`.");
  r.cssPrefix = e;
}
function Jt(r, e) {
  if (typeof e != "object")
    throw new Error("noUiSlider: 'cssClasses' must be an object.");
  typeof r.cssPrefix == "string"
    ? ((r.cssClasses = {}),
      Object.keys(e).forEach(function (s) {
        r.cssClasses[s] = r.cssPrefix + e[s];
      }))
    : (r.cssClasses = e);
}
function Te(r) {
  var e = {
      margin: null,
      limit: null,
      padding: null,
      animate: !0,
      animationDuration: 300,
      ariaFormat: Oe,
      format: Oe,
    },
    s = {
      step: { r: !1, t: Lt },
      keyboardPageMultiplier: { r: !1, t: Vt },
      keyboardMultiplier: { r: !1, t: Dt },
      keyboardDefaultStep: { r: !1, t: Ut },
      start: { r: !0, t: Ht },
      connect: { r: !0, t: Ft },
      direction: { r: !0, t: Kt },
      snap: { r: !1, t: Rt },
      animate: { r: !1, t: Ot },
      animationDuration: { r: !1, t: zt },
      range: { r: !0, t: Mt },
      orientation: { r: !1, t: qt },
      margin: { r: !1, t: je },
      limit: { r: !1, t: jt },
      padding: { r: !1, t: Tt },
      behaviour: { r: !0, t: Nt },
      ariaFormat: { r: !1, t: It },
      format: { r: !1, t: Xt },
      tooltips: { r: !1, t: $t },
      keyboardSupport: { r: !0, t: Yt },
      documentElement: { r: !1, t: Wt },
      cssPrefix: { r: !0, t: Gt },
      cssClasses: { r: !0, t: Jt },
      handleAttributes: { r: !1, t: Bt },
    },
    l = {
      connect: !1,
      direction: "ltr",
      behaviour: "tap",
      orientation: "horizontal",
      keyboardSupport: !0,
      cssPrefix: "noUi-",
      cssClasses: qe,
      keyboardPageMultiplier: 5,
      keyboardMultiplier: 1,
      keyboardDefaultStep: 10,
    };
  r.format && !r.ariaFormat && (r.ariaFormat = r.format),
    Object.keys(s).forEach(function (m) {
      if (!de(r[m]) && l[m] === void 0) {
        if (s[m].r) throw new Error("noUiSlider: '" + m + "' is required.");
        return;
      }
      s[m].t(e, de(r[m]) ? r[m] : l[m]);
    }),
    (e.pips = r.pips);
  var o = document.createElement("div"),
    h = o.style.msTransform !== void 0,
    p = o.style.transform !== void 0;
  e.transformRule = p ? "transform" : h ? "msTransform" : "webkitTransform";
  var S = [
    ["left", "top"],
    ["right", "bottom"],
  ];
  return (e.style = S[e.dir][e.ort]), e;
}
function Zt(r, e, s) {
  var l = bt(),
    o = Ct(),
    h = o && Et(),
    p = r,
    S,
    m,
    P,
    H,
    A,
    v = e.spectrum,
    O = [],
    C = [],
    M = [],
    ee = 0,
    z = {},
    N = r.ownerDocument,
    I = e.documentElement || N.documentElement,
    X = N.body,
    Ke = N.dir === "rtl" || e.ort === 1 ? 0 : 100;
  function F(t, i) {
    var a = N.createElement("div");
    return i && D(a, i), t.appendChild(a), a;
  }
  function Ne(t, i) {
    var a = F(t, e.cssClasses.origin),
      n = F(a, e.cssClasses.handle);
    if (
      (F(n, e.cssClasses.touchArea),
      n.setAttribute("data-handle", String(i)),
      e.keyboardSupport &&
        (n.setAttribute("tabindex", "0"),
        n.addEventListener("keydown", function (c) {
          return st(c, i);
        })),
      e.handleAttributes !== void 0)
    ) {
      var u = e.handleAttributes[i];
      Object.keys(u).forEach(function (c) {
        n.setAttribute(c, u[c]);
      });
    }
    return (
      n.setAttribute("role", "slider"),
      n.setAttribute("aria-orientation", e.ort ? "vertical" : "horizontal"),
      i === 0
        ? D(n, e.cssClasses.handleLower)
        : i === e.handles - 1 && D(n, e.cssClasses.handleUpper),
      (a.handle = n),
      a
    );
  }
  function ge(t, i) {
    return i ? F(t, e.cssClasses.connect) : !1;
  }
  function $e(t, i) {
    var a = F(i, e.cssClasses.connects);
    (m = []), (P = []), P.push(ge(a, t[0]));
    for (var n = 0; n < e.handles; n++)
      m.push(Ne(i, n)), (M[n] = n), P.push(ge(a, t[n + 1]));
  }
  function Be(t) {
    D(t, e.cssClasses.target),
      e.dir === 0 ? D(t, e.cssClasses.ltr) : D(t, e.cssClasses.rtl),
      e.ort === 0 ? D(t, e.cssClasses.horizontal) : D(t, e.cssClasses.vertical);
    var i = getComputedStyle(t).direction;
    return (
      i === "rtl"
        ? D(t, e.cssClasses.textDirectionRtl)
        : D(t, e.cssClasses.textDirectionLtr),
      F(t, e.cssClasses.base)
    );
  }
  function Ie(t, i) {
    return !e.tooltips || !e.tooltips[i]
      ? !1
      : F(t.firstChild, e.cssClasses.tooltip);
  }
  function Se() {
    return p.hasAttribute("disabled");
  }
  function te(t) {
    var i = m[t];
    return i.hasAttribute("disabled");
  }
  function Xe(t) {
    t != null
      ? (m[t].setAttribute("disabled", ""),
        m[t].handle.removeAttribute("tabindex"))
      : (p.setAttribute("disabled", ""),
        m.forEach(function (i) {
          i.handle.removeAttribute("tabindex");
        }));
  }
  function Ye(t) {
    t != null
      ? (m[t].removeAttribute("disabled"),
        m[t].handle.setAttribute("tabindex", "0"))
      : (p.removeAttribute("disabled"),
        m.forEach(function (i) {
          i.removeAttribute("disabled"), i.handle.setAttribute("tabindex", "0");
        }));
  }
  function re() {
    A &&
      ($("update" + q.tooltips),
      A.forEach(function (t) {
        t && Ue(t);
      }),
      (A = null));
  }
  function we() {
    re(),
      (A = m.map(Ie)),
      le("update" + q.tooltips, function (t, i, a) {
        if (!(!A || !e.tooltips) && A[i] !== !1) {
          var n = t[i];
          e.tooltips[i] !== !0 && (n = e.tooltips[i].to(a[i])),
            (A[i].innerHTML = n);
        }
      });
  }
  function We() {
    $("update" + q.aria),
      le("update" + q.aria, function (t, i, a, n, u) {
        M.forEach(function (c) {
          var d = m[c],
            f = Y(C, c, 0, !0, !0, !0),
            x = Y(C, c, 100, !0, !0, !0),
            w = u[c],
            b = String(e.ariaFormat.to(a[c]));
          (f = v.fromStepping(f).toFixed(1)),
            (x = v.fromStepping(x).toFixed(1)),
            (w = v.fromStepping(w).toFixed(1)),
            d.children[0].setAttribute("aria-valuemin", f),
            d.children[0].setAttribute("aria-valuemax", x),
            d.children[0].setAttribute("aria-valuenow", w),
            d.children[0].setAttribute("aria-valuetext", b);
        });
      });
  }
  function Ge(t) {
    if (t.mode === j.Range || t.mode === j.Steps) return v.xVal;
    if (t.mode === j.Count) {
      if (t.values < 2)
        throw new Error(
          "noUiSlider: 'values' (>= 2) required for mode 'count'."
        );
      for (var i = t.values - 1, a = 100 / i, n = []; i--; ) n[i] = i * a;
      return n.push(100), xe(n, t.stepped);
    }
    return t.mode === j.Positions
      ? xe(t.values, t.stepped)
      : t.mode === j.Values
      ? t.stepped
        ? t.values.map(function (u) {
            return v.fromStepping(v.getStep(v.toStepping(u)));
          })
        : t.values
      : [];
  }
  function xe(t, i) {
    return t.map(function (a) {
      return v.fromStepping(i ? v.getStep(a) : a);
    });
  }
  function Je(t) {
    function i(w, b) {
      return Number((w + b).toFixed(7));
    }
    var a = Ge(t),
      n = {},
      u = v.xVal[0],
      c = v.xVal[v.xVal.length - 1],
      d = !1,
      f = !1,
      x = 0;
    return (
      (a = vt(
        a.slice().sort(function (w, b) {
          return w - b;
        })
      )),
      a[0] !== u && (a.unshift(u), (d = !0)),
      a[a.length - 1] !== c && (a.push(c), (f = !0)),
      a.forEach(function (w, b) {
        var E,
          g,
          y,
          V = w,
          k = a[b + 1],
          L,
          ue,
          fe,
          he,
          Le,
          pe,
          Ve,
          De = t.mode === j.Steps;
        for (
          De && (E = v.xNumSteps[b]),
            E || (E = k - V),
            k === void 0 && (k = V),
            E = Math.max(E, 1e-7),
            g = V;
          g <= k;
          g = i(g, E)
        ) {
          for (
            L = v.toStepping(g),
              ue = L - x,
              Le = ue / (t.density || 1),
              pe = Math.round(Le),
              Ve = ue / pe,
              y = 1;
            y <= pe;
            y += 1
          )
            (fe = x + y * Ve), (n[fe.toFixed(5)] = [v.fromStepping(fe), 0]);
          (he =
            a.indexOf(g) > -1 ? U.LargeValue : De ? U.SmallValue : U.NoValue),
            !b && d && g !== k && (he = 0),
            (g === k && f) || (n[L.toFixed(5)] = [g, he]),
            (x = L);
        }
      }),
      n
    );
  }
  function Ze(t, i, a) {
    var n,
      u,
      c = N.createElement("div"),
      d =
        ((n = {}),
        (n[U.None] = ""),
        (n[U.NoValue] = e.cssClasses.valueNormal),
        (n[U.LargeValue] = e.cssClasses.valueLarge),
        (n[U.SmallValue] = e.cssClasses.valueSub),
        n),
      f =
        ((u = {}),
        (u[U.None] = ""),
        (u[U.NoValue] = e.cssClasses.markerNormal),
        (u[U.LargeValue] = e.cssClasses.markerLarge),
        (u[U.SmallValue] = e.cssClasses.markerSub),
        u),
      x = [e.cssClasses.valueHorizontal, e.cssClasses.valueVertical],
      w = [e.cssClasses.markerHorizontal, e.cssClasses.markerVertical];
    D(c, e.cssClasses.pips),
      D(
        c,
        e.ort === 0 ? e.cssClasses.pipsHorizontal : e.cssClasses.pipsVertical
      );
    function b(g, y) {
      var V = y === e.cssClasses.value,
        k = V ? x : w,
        L = V ? d : f;
      return y + " " + k[e.ort] + " " + L[g];
    }
    function E(g, y, V) {
      if (((V = i ? i(y, V) : V), V !== U.None)) {
        var k = F(c, !1);
        (k.className = b(V, e.cssClasses.marker)),
          (k.style[e.style] = g + "%"),
          V > U.NoValue &&
            ((k = F(c, !1)),
            (k.className = b(V, e.cssClasses.value)),
            k.setAttribute("data-value", String(y)),
            (k.style[e.style] = g + "%"),
            (k.innerHTML = String(a.to(y))));
      }
    }
    return (
      Object.keys(t).forEach(function (g) {
        E(g, t[g][0], t[g][1]);
      }),
      c
    );
  }
  function ie() {
    H && (Ue(H), (H = null));
  }
  function ae(t) {
    ie();
    var i = Je(t),
      a = t.filter,
      n = t.format || {
        to: function (u) {
          return String(Math.round(u));
        },
      };
    return (H = p.appendChild(Ze(i, a, n))), H;
  }
  function be() {
    var t = S.getBoundingClientRect(),
      i = "offset" + ["Width", "Height"][e.ort];
    return e.ort === 0 ? t.width || S[i] : t.height || S[i];
  }
  function T(t, i, a, n) {
    var u = function (d) {
        var f = Qe(d, n.pageOffset, n.target || i);
        if (
          !f ||
          (Se() && !n.doNotReject) ||
          (xt(p, e.cssClasses.tap) && !n.doNotReject) ||
          (t === l.start && f.buttons !== void 0 && f.buttons > 1) ||
          (n.hover && f.buttons)
        )
          return !1;
        h || f.preventDefault(), (f.calcPoint = f.points[e.ort]), a(f, n);
      },
      c = [];
    return (
      t.split(" ").forEach(function (d) {
        i.addEventListener(d, u, h ? { passive: !0 } : !1), c.push([d, u]);
      }),
      c
    );
  }
  function Qe(t, i, a) {
    var n = t.type.indexOf("touch") === 0,
      u = t.type.indexOf("mouse") === 0,
      c = t.type.indexOf("pointer") === 0,
      d = 0,
      f = 0;
    if (
      (t.type.indexOf("MSPointer") === 0 && (c = !0),
      t.type === "mousedown" && !t.buttons && !t.touches)
    )
      return !1;
    if (n) {
      var x = function (E) {
        var g = E.target;
        return (
          g === a ||
          a.contains(g) ||
          (t.composed && t.composedPath().shift() === a)
        );
      };
      if (t.type === "touchstart") {
        var w = Array.prototype.filter.call(t.touches, x);
        if (w.length > 1) return !1;
        (d = w[0].pageX), (f = w[0].pageY);
      } else {
        var b = Array.prototype.find.call(t.changedTouches, x);
        if (!b) return !1;
        (d = b.pageX), (f = b.pageY);
      }
    }
    return (
      (i = i || ze(N)),
      (u || c) && ((d = t.clientX + i.x), (f = t.clientY + i.y)),
      (t.pageOffset = i),
      (t.points = [d, f]),
      (t.cursor = u || c),
      t
    );
  }
  function Ee(t) {
    var i = t - St(S, e.ort),
      a = (i * 100) / be();
    return (a = Re(a)), e.dir ? 100 - a : a;
  }
  function et(t) {
    var i = 100,
      a = !1;
    return (
      m.forEach(function (n, u) {
        if (!te(u)) {
          var c = C[u],
            d = Math.abs(c - t),
            f = d === 100 && i === 100,
            x = d < i,
            w = d <= i && t > c;
          (x || w || f) && ((a = u), (i = d));
        }
      }),
      a
    );
  }
  function tt(t, i) {
    t.type === "mouseout" &&
      t.target.nodeName === "HTML" &&
      t.relatedTarget === null &&
      se(t, i);
  }
  function rt(t, i) {
    if (
      navigator.appVersion.indexOf("MSIE 9") === -1 &&
      t.buttons === 0 &&
      i.buttonsProperty !== 0
    )
      return se(t, i);
    var a = (e.dir ? -1 : 1) * (t.calcPoint - i.startCalcPoint),
      n = (a * 100) / i.baseSize;
    Ce(a > 0, n, i.locations, i.handleNumbers, i.connect);
  }
  function se(t, i) {
    i.handle && (J(i.handle, e.cssClasses.active), (ee -= 1)),
      i.listeners.forEach(function (a) {
        I.removeEventListener(a[0], a[1]);
      }),
      ee === 0 &&
        (J(p, e.cssClasses.drag),
        ce(),
        t.cursor &&
          ((X.style.cursor = ""), X.removeEventListener("selectstart", Me))),
      e.events.smoothSteps &&
        (i.handleNumbers.forEach(function (a) {
          K(a, C[a], !0, !0, !1, !1);
        }),
        i.handleNumbers.forEach(function (a) {
          _("update", a);
        })),
      i.handleNumbers.forEach(function (a) {
        _("change", a), _("set", a), _("end", a);
      });
  }
  function ne(t, i) {
    if (!i.handleNumbers.some(te)) {
      var a;
      if (i.handleNumbers.length === 1) {
        var n = m[i.handleNumbers[0]];
        (a = n.children[0]), (ee += 1), D(a, e.cssClasses.active);
      }
      t.stopPropagation();
      var u = [],
        c = T(l.move, I, rt, {
          target: t.target,
          handle: a,
          connect: i.connect,
          listeners: u,
          startCalcPoint: t.calcPoint,
          baseSize: be(),
          pageOffset: t.pageOffset,
          handleNumbers: i.handleNumbers,
          buttonsProperty: t.buttons,
          locations: C.slice(),
        }),
        d = T(l.end, I, se, {
          target: t.target,
          handle: a,
          listeners: u,
          doNotReject: !0,
          handleNumbers: i.handleNumbers,
        }),
        f = T("mouseout", I, tt, {
          target: t.target,
          handle: a,
          listeners: u,
          doNotReject: !0,
          handleNumbers: i.handleNumbers,
        });
      u.push.apply(u, c.concat(d, f)),
        t.cursor &&
          ((X.style.cursor = getComputedStyle(t.target).cursor),
          m.length > 1 && D(p, e.cssClasses.drag),
          X.addEventListener("selectstart", Me, !1)),
        i.handleNumbers.forEach(function (x) {
          _("start", x);
        });
    }
  }
  function it(t) {
    t.stopPropagation();
    var i = Ee(t.calcPoint),
      a = et(i);
    a !== !1 &&
      (e.events.snap || He(p, e.cssClasses.tap, e.animationDuration),
      K(a, i, !0, !0),
      ce(),
      _("slide", a, !0),
      _("update", a, !0),
      e.events.snap
        ? ne(t, { handleNumbers: [a] })
        : (_("change", a, !0), _("set", a, !0)));
  }
  function at(t) {
    var i = Ee(t.calcPoint),
      a = v.getStep(i),
      n = v.fromStepping(a);
    Object.keys(z).forEach(function (u) {
      u.split(".")[0] === "hover" &&
        z[u].forEach(function (c) {
          c.call(G, n);
        });
    });
  }
  function st(t, i) {
    if (Se() || te(i)) return !1;
    var a = ["Left", "Right"],
      n = ["Down", "Up"],
      u = ["PageDown", "PageUp"],
      c = ["Home", "End"];
    e.dir && !e.ort
      ? a.reverse()
      : e.ort && !e.dir && (n.reverse(), u.reverse());
    var d = t.key.replace("Arrow", ""),
      f = d === u[0],
      x = d === u[1],
      w = d === n[0] || d === a[0] || f,
      b = d === n[1] || d === a[1] || x,
      E = d === c[0],
      g = d === c[1];
    if (!w && !b && !E && !g) return !0;
    t.preventDefault();
    var y;
    if (b || w) {
      var V = w ? 0 : 1,
        k = ke(i),
        L = k[V];
      if (L === null) return !1;
      L === !1 && (L = v.getDefaultStep(C[i], w, e.keyboardDefaultStep)),
        x || f ? (L *= e.keyboardPageMultiplier) : (L *= e.keyboardMultiplier),
        (L = Math.max(L, 1e-7)),
        (L = (w ? -1 : 1) * L),
        (y = O[i] + L);
    } else
      g
        ? (y = e.spectrum.xVal[e.spectrum.xVal.length - 1])
        : (y = e.spectrum.xVal[0]);
    return (
      K(i, v.toStepping(y), !0, !0),
      _("slide", i),
      _("update", i),
      _("change", i),
      _("set", i),
      !1
    );
  }
  function nt(t) {
    t.fixed ||
      m.forEach(function (i, a) {
        T(l.start, i.children[0], ne, { handleNumbers: [a] });
      }),
      t.tap && T(l.start, S, it, {}),
      t.hover && T(l.move, S, at, { hover: !0 }),
      t.drag &&
        P.forEach(function (i, a) {
          if (!(i === !1 || a === 0 || a === P.length - 1)) {
            var n = m[a - 1],
              u = m[a],
              c = [i],
              d = [n, u],
              f = [a - 1, a];
            D(i, e.cssClasses.draggable),
              t.fixed && (c.push(n.children[0]), c.push(u.children[0])),
              t.dragAll && ((d = m), (f = M)),
              c.forEach(function (x) {
                T(l.start, x, ne, { handles: d, handleNumbers: f, connect: i });
              });
          }
        });
  }
  function le(t, i) {
    (z[t] = z[t] || []),
      z[t].push(i),
      t.split(".")[0] === "update" &&
        m.forEach(function (a, n) {
          _("update", n);
        });
  }
  function lt(t) {
    return t === q.aria || t === q.tooltips;
  }
  function $(t) {
    var i = t && t.split(".")[0],
      a = i ? t.substring(i.length) : t;
    Object.keys(z).forEach(function (n) {
      var u = n.split(".")[0],
        c = n.substring(u.length);
      (!i || i === u) && (!a || a === c) && (!lt(c) || a === c) && delete z[n];
    });
  }
  function _(t, i, a) {
    Object.keys(z).forEach(function (n) {
      var u = n.split(".")[0];
      t === u &&
        z[n].forEach(function (c) {
          c.call(G, O.map(e.format.to), i, O.slice(), a || !1, C.slice(), G);
        });
    });
  }
  function Y(t, i, a, n, u, c, d) {
    var f;
    return (
      m.length > 1 &&
        !e.events.unconstrained &&
        (n &&
          i > 0 &&
          ((f = v.getAbsoluteDistance(t[i - 1], e.margin, !1)),
          (a = Math.max(a, f))),
        u &&
          i < m.length - 1 &&
          ((f = v.getAbsoluteDistance(t[i + 1], e.margin, !0)),
          (a = Math.min(a, f)))),
      m.length > 1 &&
        e.limit &&
        (n &&
          i > 0 &&
          ((f = v.getAbsoluteDistance(t[i - 1], e.limit, !1)),
          (a = Math.min(a, f))),
        u &&
          i < m.length - 1 &&
          ((f = v.getAbsoluteDistance(t[i + 1], e.limit, !0)),
          (a = Math.max(a, f)))),
      e.padding &&
        (i === 0 &&
          ((f = v.getAbsoluteDistance(0, e.padding[0], !1)),
          (a = Math.max(a, f))),
        i === m.length - 1 &&
          ((f = v.getAbsoluteDistance(100, e.padding[1], !0)),
          (a = Math.min(a, f)))),
      d || (a = v.getStep(a)),
      (a = Re(a)),
      a === t[i] && !c ? !1 : a
    );
  }
  function oe(t, i) {
    var a = e.ort;
    return (a ? i : t) + ", " + (a ? t : i);
  }
  function Ce(t, i, a, n, u) {
    var c = a.slice(),
      d = n[0],
      f = e.events.smoothSteps,
      x = [!t, t],
      w = [t, !t];
    (n = n.slice()),
      t && n.reverse(),
      n.length > 1
        ? n.forEach(function (E, g) {
            var y = Y(c, E, c[E] + i, x[g], w[g], !1, f);
            y === !1 ? (i = 0) : ((i = y - c[E]), (c[E] = y));
          })
        : (x = w = [!0]);
    var b = !1;
    n.forEach(function (E, g) {
      b = K(E, a[E] + i, x[g], w[g], !1, f) || b;
    }),
      b &&
        (n.forEach(function (E) {
          _("update", E), _("slide", E);
        }),
        u != null && _("drag", d));
  }
  function _e(t, i) {
    return e.dir ? 100 - t - i : t;
  }
  function ot(t, i) {
    (C[t] = i), (O[t] = v.fromStepping(i));
    var a = _e(i, 0) - Ke,
      n = "translate(" + oe(a + "%", "0") + ")";
    (m[t].style[e.transformRule] = n), ye(t), ye(t + 1);
  }
  function ce() {
    M.forEach(function (t) {
      var i = C[t] > 50 ? -1 : 1,
        a = 3 + (m.length + i * t);
      m[t].style.zIndex = String(a);
    });
  }
  function K(t, i, a, n, u, c) {
    return u || (i = Y(C, t, i, a, n, !1, c)), i === !1 ? !1 : (ot(t, i), !0);
  }
  function ye(t) {
    if (P[t]) {
      var i = 0,
        a = 100;
      t !== 0 && (i = C[t - 1]), t !== P.length - 1 && (a = C[t]);
      var n = a - i,
        u = "translate(" + oe(_e(i, n) + "%", "0") + ")",
        c = "scale(" + oe(n / 100, "1") + ")";
      P[t].style[e.transformRule] = u + " " + c;
    }
  }
  function Pe(t, i) {
    return t === null ||
      t === !1 ||
      t === void 0 ||
      (typeof t == "number" && (t = String(t)),
      (t = e.format.from(t)),
      t !== !1 && (t = v.toStepping(t)),
      t === !1 || isNaN(t))
      ? C[i]
      : t;
  }
  function W(t, i, a) {
    var n = Q(t),
      u = C[0] === void 0;
    (i = i === void 0 ? !0 : i),
      e.animate && !u && He(p, e.cssClasses.tap, e.animationDuration),
      M.forEach(function (f) {
        K(f, Pe(n[f], f), !0, !1, a);
      });
    var c = M.length === 1 ? 0 : 1;
    if (u && v.hasNoSize() && ((a = !0), (C[0] = 0), M.length > 1)) {
      var d = 100 / (M.length - 1);
      M.forEach(function (f) {
        C[f] = f * d;
      });
    }
    for (; c < M.length; ++c)
      M.forEach(function (f) {
        K(f, C[f], !0, !0, a);
      });
    ce(),
      M.forEach(function (f) {
        _("update", f), n[f] !== null && i && _("set", f);
      });
  }
  function ct(t) {
    W(e.start, t);
  }
  function ut(t, i, a, n) {
    if (((t = Number(t)), !(t >= 0 && t < M.length)))
      throw new Error("noUiSlider: invalid handle number, got: " + t);
    K(t, Pe(i, t), !0, !0, n), _("update", t), a && _("set", t);
  }
  function Ae(t) {
    if ((t === void 0 && (t = !1), t))
      return O.length === 1 ? O[0] : O.slice(0);
    var i = O.map(e.format.to);
    return i.length === 1 ? i[0] : i;
  }
  function ft() {
    for (
      $(q.aria),
        $(q.tooltips),
        Object.keys(e.cssClasses).forEach(function (t) {
          J(p, e.cssClasses[t]);
        });
      p.firstChild;

    )
      p.removeChild(p.firstChild);
    delete p.noUiSlider;
  }
  function ke(t) {
    var i = C[t],
      a = v.getNearbySteps(i),
      n = O[t],
      u = a.thisStep.step,
      c = null;
    if (e.snap)
      return [
        n - a.stepBefore.startValue || null,
        a.stepAfter.startValue - n || null,
      ];
    u !== !1 &&
      n + u > a.stepAfter.startValue &&
      (u = a.stepAfter.startValue - n),
      n > a.thisStep.startValue
        ? (c = a.thisStep.step)
        : a.stepBefore.step === !1
        ? (c = !1)
        : (c = n - a.stepBefore.highestStep),
      i === 100 ? (u = null) : i === 0 && (c = null);
    var d = v.countStepDecimals();
    return (
      u !== null && u !== !1 && (u = Number(u.toFixed(d))),
      c !== null && c !== !1 && (c = Number(c.toFixed(d))),
      [c, u]
    );
  }
  function ht() {
    return M.map(ke);
  }
  function pt(t, i) {
    var a = Ae(),
      n = [
        "margin",
        "limit",
        "padding",
        "range",
        "animate",
        "snap",
        "step",
        "format",
        "pips",
        "tooltips",
      ];
    n.forEach(function (c) {
      t[c] !== void 0 && (s[c] = t[c]);
    });
    var u = Te(s);
    n.forEach(function (c) {
      t[c] !== void 0 && (e[c] = u[c]);
    }),
      (v = u.spectrum),
      (e.margin = u.margin),
      (e.limit = u.limit),
      (e.padding = u.padding),
      e.pips ? ae(e.pips) : ie(),
      e.tooltips ? we() : re(),
      (C = []),
      W(de(t.start) ? t.start : a, i);
  }
  function dt() {
    (S = Be(p)),
      $e(e.connect, S),
      nt(e.events),
      W(e.start),
      e.pips && ae(e.pips),
      e.tooltips && we(),
      We();
  }
  dt();
  var G = {
    destroy: ft,
    steps: ht,
    on: le,
    off: $,
    get: Ae,
    set: W,
    setHandle: ut,
    reset: ct,
    disable: Xe,
    enable: Ye,
    __moveHandles: function (t, i, a) {
      Ce(t, i, C, a);
    },
    options: s,
    updateOptions: pt,
    target: p,
    removePips: ie,
    removeTooltips: re,
    getPositions: function () {
      return C.slice();
    },
    getTooltips: function () {
      return A;
    },
    getOrigins: function () {
      return m;
    },
    pips: ae,
  };
  return G;
}
function Qt(r, e) {
  if (!r || !r.nodeName)
    throw new Error("noUiSlider: create requires a single element, got: " + r);
  if (r.noUiSlider)
    throw new Error("noUiSlider: Slider was already initialized.");
  var s = Te(e),
    l = Zt(r, s, e);
  return (r.noUiSlider = l), l;
}
const er = { __spectrum: Fe, cssClasses: qe, create: Qt };
class tr extends HTMLElement {
  constructor() {
    super(),
      (this.url = new URL(window.location.href)),
      (this.is_loading = !1),
      (this.tags = theme.filters.tags),
      (this.original_url = theme.filters.url),
      (this.section_id = theme.filters.section_id),
      (this.price = {
        max_price: theme.filters.max_price,
        min_price: theme.filters.min_price,
        start_price: theme.filters.start_price,
        end_price: theme.filters.end_price,
      });
  }
  connectedCallback() {
    (this.sections = this.querySelector("input[data-sections]").value.split(
      ","
    )),
      this.loadCallback();
  }
  loadCallback() {
    this.checkSize(),
      this.querySelectorAll('button[type="reset"]').forEach((e) => {
        e.addEventListener("click", (s) => {
          e.hasAttribute("data-filter")
            ? e.hasAttribute("data-value")
              ? this.resetFilterKeyValue(e.dataset.filter, e.dataset.value)
              : this.resetFilterKey(e.dataset.filter)
            : e.hasAttribute("data-price")
            ? this.resetPrice()
            : this.resetAllFilters();
        });
      }),
      this.querySelectorAll('button[type="submit"]').forEach((e) => {
        e.addEventListener("click", (s) => {
          s.preventDefault(), this.applyFilters();
        });
      }),
      this.querySelectorAll(".filter_price_range").forEach((e) => {
        this.createSlider(e);
      }),
      (document.body.style.overflow = null);
  }
  checkSize() {
    [".size_filter", ".size_filter_mobile"].forEach((s) => {
      if (this.querySelector(s) || !1) {
        let o = new URL(window.location.href),
          h = new URLSearchParams(o.search);
        h.set("filter.v.availability", "1"),
          h.set("section_id", this.section_id);
        let p = `${o.origin}${o.pathname}?${h.toString()}`;
        fetch(p)
          .then((S) => S.text())
          .then((S) => {
            const m = document.createElement("div");
            m.innerHTML = S;
            const P = m.querySelector(s);
            P &&
              P.innerHTML.trim().length &&
              (document.querySelector(s).outerHTML = P.outerHTML);
          });
      }
    });
  }
  resetAllFilters() {
    let e = new URL(window.location.href),
      s = new URLSearchParams(),
      l = new URLSearchParams(e.search);
    for (let o of l.keys()) o == "q" && s.append("q", l.get("q"));
    (this.tags = []), this.updateSections(s.toString());
  }
  resetPrice() {
    let e = new URL(window.location.href),
      s = new URLSearchParams(e.search);
    s.delete("filter.v.price.gte"),
      s.delete("filter.v.price.lte"),
      (theme.filters.start_price = theme.filters.min_price),
      (theme.filters.end_price = theme.filters.max_price),
      this.updateSections(s.toString());
  }
  resetFilterKey(e) {
    let s = new URL(window.location.href),
      l = this.deleteParamsKey(new URLSearchParams(s.search), e);
    this.updateSections(l.toString());
  }
  resetFilterKeyValue(e, s) {
    let l = new URL(window.location.href),
      o = this.deleteParamsEntry(new URLSearchParams(l.search), e, s);
    this.updateSections(o.toString());
  }
  deleteParamsKey(e, s) {
    const l = Array.from(e.entries()).filter(([o, h]) => o !== s);
    return new URLSearchParams(l);
  }
  deleteParamsEntry(e, s, l) {
    const o = Array.from(e.entries()).filter(([h, p]) => !(h === s && p === l));
    return new URLSearchParams(o);
  }
  createSlider(e) {
    let s = e.querySelector("[data-min-price]"),
      l = e.querySelector("[data-max-price]"),
      o = e.querySelector(".priceSlider");
    er.create(o, {
      start: [this.price.start_price, this.price.end_price],
      connect: !0,
      step: 1,
      range: { min: this.price.min_price, max: this.price.max_price },
    }),
      (s.innerHTML = this.price.min_price),
      (l.innerHTML = this.price.max_price),
      o.noUiSlider.on("update", (h, p) => {
        p == 0
          ? ((this.price.start_price = h[p]),
            (theme.filters.start_price = h[p]),
            (s.innerHTML = h[p]))
          : ((this.price.end_price = h[p]),
            (theme.filters.end_price = h[p]),
            (l.innerHTML = h[p]));
      });
  }
  getCurrentParams() {
    let e = new URL(window.location.href),
      s = new URLSearchParams(),
      l = new URLSearchParams(e.search);
    for (let o of l.keys()) o == "q" && s.append("q", l.get("q"));
    return s;
  }
  getBaseUrl() {
    return this.tags.length == 0
      ? this.original_url
      : `${this.original_url}/${this.tags.join("+")}`;
  }
  applyFilters() {
    let e = this.getCurrentParams(),
      s = !1;
    this.querySelectorAll('input[type="checkbox"]').forEach((o) => {
      o.checked &&
        (e.append(o.name, o.value),
        o.classList.contains("size_option") && (s = !0));
    }),
      s && e.append("filter.v.availability", "1");
    let l = this.querySelector('input[name="sort-by"]:checked') || !1;
    l && e.append("sort_by", l.value),
      (this.price.start_price != this.price.min_price ||
        this.price.end_price != this.price.max_price) &&
        (e.append("filter.v.price.gte", this.price.start_price),
        e.append("filter.v.price.lte", this.price.end_price)),
      this.updateSections(e.toString());
  }
  async updateSections(e) {
    if (this.is_loading == !0) return;
    this.is_loading = !0;
    let s = this.getBaseUrl(),
      l = e === "" ? s : `${s}?${e}`,
      o =
        e === ""
          ? `${s}?section_id=${this.section_id}`
          : `${s}?${e}&section_id=${this.section_id}`;
    await fetch(o)
      .then((h) => h.text())
      .then((h) => {
        history.pushState({}, null, l), this.renderSection(h);
      }),
      (this.is_loading = !1);
  }
  renderSection(e) {
    this.sections.forEach((s) => {
      const l = document.querySelector(s) || !1;
      l && (l.outerHTML = this.getSectionDOM(e, s).outerHTML);
    }),
      this.loadCallback();
  }
  getSectionDOM(e, s = ".shopify-section") {
    return new DOMParser().parseFromString(e, "text/html").querySelector(s);
  }
}
customElements.define("drop-filters", tr);
